import stripes from 'assets/details/Print_Stripes.svg';
import animalPrints from 'assets/details/Print-01.svg';
import checkedPrints from 'assets/details/Print-02.svg';
import embroidered from 'assets/details/Print-03.svg';
import flowerPrints from 'assets/details/Print-04.svg';
import polkaDots from 'assets/details/Print-06.svg';
import lace from 'assets/details/Print-07.svg';
import geoPrints from 'assets/details/Print-08.svg';
import denim from 'assets/details/denim.svg';
import plain from 'assets/details/Print-10.svg';
import metallic from 'assets/details/Petrified-Alien-Blossom.svg';
import logoPrints from 'assets/details/Print-12.svg';
import pattern from 'assets/details/Print-13.svg';
import retro from 'assets/details/retro-prints.svg';
import glitter from 'assets/details/glitter.svg';
import selfPrint from 'assets/details/self-print.svg';
import fauxLeather from 'assets/details/cruelty-free.svg';
import transparent from 'assets/details/transparent.svg';

const DEFAULT_DETAILS = [
  { value: 'Animal Prints', label: 'Animal Prints', icon: animalPrints },
  { value: 'Checked Prints', label: 'Checked Prints', icon: checkedPrints },
  { value: 'Embroidered', label: 'Embroidered', icon: embroidered },
  { value: 'Flower Prints', label: 'Flower Prints', icon: flowerPrints },
  { value: 'Geometric Prints', label: 'Geometric Prints', icon: geoPrints },
  { value: 'Lace', label: 'Lace', icon: lace },
  { value: 'Logo Print', label: 'Logo Print', icon: logoPrints },
  { value: 'Pattern', label: 'Pattern', icon: pattern },
  { value: 'Plain', label: 'Plain', icon: plain },
  { value: 'Polka Dots', label: 'Polka Dots', icon: polkaDots },
  { value: 'Retro Prints', label: 'Retro Prints', icon: retro },
  { value: 'Stripes', label: 'Stripes', icon: stripes },
  { value: 'Denim', label: 'Denim', icon: denim },
  { value: 'Faux Leather', label: 'Faux Leather', icon: fauxLeather },
  { value: 'Glitter', label: 'Glitter', icon: glitter },
  { value: 'Self Print', label: 'Self Print', icon: selfPrint },
  { value: 'Transparent', label: 'Transparent', icon: transparent },
  { value: 'Metallic', label: 'Metallic', icon: metallic }
];


/**
 * Return an array of objects
 */
export function getDetails() {
  return DEFAULT_DETAILS;
}
